import { emptySplitApi as api } from "./emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    administrationSsoGet: build.query<
      AdministrationSsoGetApiResponse,
      AdministrationSsoGetApiArg
    >({
      query: () => ({ url: `/api/v1/administration-sso` }),
    }),
    administrationSsoUpdate: build.mutation<
      AdministrationSsoUpdateApiResponse,
      AdministrationSsoUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/administration-sso`,
        method: "PUT",
        body: queryArg.updateAdministrationSsoRequest,
      }),
    }),
    administrationSsoDelete: build.mutation<
      AdministrationSsoDeleteApiResponse,
      AdministrationSsoDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/administration-sso`,
        method: "DELETE",
        body: queryArg.deleteAdministrationSsoRequest,
      }),
    }),
    administrationSsoValidate: build.mutation<
      AdministrationSsoValidateApiResponse,
      AdministrationSsoValidateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/administration-sso/validate`,
        method: "PUT",
        body: queryArg.updateAdministrationSsoRequest,
      }),
    }),
    applicationSearch: build.mutation<
      ApplicationSearchApiResponse,
      ApplicationSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/application`,
        method: "POST",
        body: queryArg.searchApplicationRequest,
      }),
    }),
    applicationUpdate: build.mutation<
      ApplicationUpdateApiResponse,
      ApplicationUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/application`,
        method: "PUT",
        body: queryArg.updateApplicationRequest,
      }),
    }),
    applicationDelete: build.mutation<
      ApplicationDeleteApiResponse,
      ApplicationDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/application`,
        method: "DELETE",
        body: queryArg.deleteApplicationRequest,
      }),
    }),
    clientRegistrationSearch: build.mutation<
      ClientRegistrationSearchApiResponse,
      ClientRegistrationSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/clientRegistration`,
        method: "POST",
        body: queryArg.searchClientRegistrationRequest,
      }),
    }),
    clientRegistrationUpdate: build.mutation<
      ClientRegistrationUpdateApiResponse,
      ClientRegistrationUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/clientRegistration`,
        method: "PUT",
        body: queryArg.updateClientRegistrationRequest,
      }),
    }),
    clientRegistrationDelete: build.mutation<
      ClientRegistrationDeleteApiResponse,
      ClientRegistrationDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/clientRegistration`,
        method: "DELETE",
        body: queryArg.deleteClientRegistrationRequest,
      }),
    }),
    clientRegistrationGet: build.query<
      ClientRegistrationGetApiResponse,
      ClientRegistrationGetApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/clientRegistration/${queryArg.id}`,
      }),
    }),
    consumptionPageUsers: build.mutation<
      ConsumptionPageUsersApiResponse,
      ConsumptionPageUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/consumptions/users`,
        method: "POST",
        body: queryArg.searchUsersWithActiveSubscriptionRequest,
      }),
    }),
    consumptionPagePeriods: build.mutation<
      ConsumptionPagePeriodsApiResponse,
      ConsumptionPagePeriodsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/consumptions/periods`,
        method: "POST",
        body: queryArg.searchPeriodsOfActiveSubscriptionsRequest,
      }),
    }),
    consumptionPageQuotas: build.mutation<
      ConsumptionPageQuotasApiResponse,
      ConsumptionPageQuotasApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/consumptions/quotas`,
        method: "POST",
        body: queryArg.searchUserConsumptionsSerialRequest,
      }),
    }),
    csmConfigurationGetCsmConfiguration: build.query<
      CsmConfigurationGetCsmConfigurationApiResponse,
      CsmConfigurationGetCsmConfigurationApiArg
    >({
      query: () => ({ url: `/api/v1/public/.well-known/csm-configuration` }),
    }),
    documentsDownload: build.query<
      DocumentsDownloadApiResponse,
      DocumentsDownloadApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/public/documents/${queryArg.product}/${queryArg.documentType}`,
      }),
    }),
    healthCheckHealthCheck: build.query<
      HealthCheckHealthCheckApiResponse,
      HealthCheckHealthCheckApiArg
    >({
      query: () => ({ url: `/api/v1/public/health-check` }),
    }),
    healthCheckHealthCheckBackEnd: build.query<
      HealthCheckHealthCheckBackEndApiResponse,
      HealthCheckHealthCheckBackEndApiArg
    >({
      query: () => ({ url: `/api/v1/public/health-check-be` }),
    }),
    orderSearch: build.mutation<OrderSearchApiResponse, OrderSearchApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/order`,
        method: "POST",
        body: queryArg.searchOrderRequest,
      }),
    }),
    orderGet: build.query<OrderGetApiResponse, OrderGetApiArg>({
      query: (queryArg) => ({ url: `/api/v1/order/${queryArg.id}` }),
    }),
    productSearchOwn: build.mutation<
      ProductSearchOwnApiResponse,
      ProductSearchOwnApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/product/own-families`,
        method: "POST",
        body: queryArg.searchOwnProductFamilyRequest,
      }),
    }),
    productGetOwn: build.query<ProductGetOwnApiResponse, ProductGetOwnApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/tool/own-product`,
        body: queryArg.getOwnProductRequest,
      }),
    }),
    productSearch: build.mutation<
      ProductSearchApiResponse,
      ProductSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/product`,
        method: "POST",
        body: queryArg.searchProductRequest,
      }),
    }),
    registrationPageCompany: build.mutation<
      RegistrationPageCompanyApiResponse,
      RegistrationPageCompanyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/public/register-company`,
        method: "PUT",
        body: queryArg.registerCompanyRequest,
      }),
    }),
    serialNumberSearch: build.mutation<
      SerialNumberSearchApiResponse,
      SerialNumberSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/serial-numbers`,
        method: "POST",
        body: queryArg.searchSerialNumberRequest,
      }),
    }),
    serialNumberCreate: build.mutation<
      SerialNumberCreateApiResponse,
      SerialNumberCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/serial-numbers`,
        method: "PUT",
        body: queryArg.createSerialNumberRequest,
      }),
    }),
    serialNumberActivationRenewalSerialNumber: build.mutation<
      SerialNumberActivationRenewalSerialNumberApiResponse,
      SerialNumberActivationRenewalSerialNumberApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/serial-numbers/activation-renewal`,
        method: "POST",
        body: queryArg.activationRenewalRequest,
      }),
    }),
    subscriptionSearchUser: build.mutation<
      SubscriptionSearchUserApiResponse,
      SubscriptionSearchUserApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/subscription/user`,
        method: "POST",
        body: queryArg.searchSubscriptionUserRequest,
      }),
    }),
    subscriptionSearch: build.mutation<
      SubscriptionSearchApiResponse,
      SubscriptionSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/subscription`,
        method: "POST",
        body: queryArg.searchActiveSubscriptionRequest,
      }),
    }),
    subscriptionUpdate: build.mutation<
      SubscriptionUpdateApiResponse,
      SubscriptionUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/subscription`,
        method: "PUT",
        body: queryArg.updateUserSubscriptionRequest,
      }),
    }),
    subscriptionDelete: build.mutation<
      SubscriptionDeleteApiResponse,
      SubscriptionDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/subscription`,
        method: "DELETE",
        body: queryArg.updateUserSubscriptionRequest,
      }),
    }),
    tenantSearch: build.mutation<TenantSearchApiResponse, TenantSearchApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/tenant`,
        method: "POST",
        body: queryArg.searchTenantRequest,
      }),
    }),
    termsAndConditionsSearchAuthenticated: build.mutation<
      TermsAndConditionsSearchAuthenticatedApiResponse,
      TermsAndConditionsSearchAuthenticatedApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/terms-and-conditions`,
        method: "POST",
        body: queryArg.searchTermsAndConditionsBySerialNumberRequest,
      }),
    }),
    termsAndConditionsSearchPublic: build.mutation<
      TermsAndConditionsSearchPublicApiResponse,
      TermsAndConditionsSearchPublicApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/public/terms-and-conditions`,
        method: "POST",
        body: queryArg.searchTermsAndConditionsBySerialNumberRequest,
      }),
    }),
    userActivityLogSearch: build.mutation<
      UserActivityLogSearchApiResponse,
      UserActivityLogSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/user/user-activity-log`,
        method: "POST",
        body: queryArg.searchUserActivityLogRequest,
      }),
    }),
    userSearch: build.mutation<UserSearchApiResponse, UserSearchApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/user`,
        method: "POST",
        body: queryArg.searchUserRequest,
      }),
    }),
    userUpdate: build.mutation<UserUpdateApiResponse, UserUpdateApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/user`,
        method: "PUT",
        body: queryArg.updateUserRequest,
      }),
    }),
    userDelete: build.mutation<UserDeleteApiResponse, UserDeleteApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/user`,
        method: "DELETE",
        body: queryArg.deleteUserRequest,
      }),
    }),
    userQuotaGet: build.query<UserQuotaGetApiResponse, UserQuotaGetApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/integration/quota/${queryArg.serviceSlug}/${queryArg.userId}`,
      }),
    }),
    userQuotaPost: build.mutation<
      UserQuotaPostApiResponse,
      UserQuotaPostApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/integration/quota/${queryArg.serviceSlug}/${queryArg.userId}`,
        method: "POST",
        body: queryArg.updateUserQuotaRequest,
      }),
    }),
    versionVersion: build.query<
      VersionVersionApiResponse,
      VersionVersionApiArg
    >({
      query: () => ({ url: `/api/v1/public/version` }),
    }),
    getApiV1WellKnownOpenidConfiguration: build.query<
      GetApiV1WellKnownOpenidConfigurationApiResponse,
      GetApiV1WellKnownOpenidConfigurationApiArg
    >({
      query: () => ({ url: `/api/v1/.well-known/openid-configuration` }),
    }),
    getApiV1WellKnownJwksJson: build.query<
      GetApiV1WellKnownJwksJsonApiResponse,
      GetApiV1WellKnownJwksJsonApiArg
    >({
      query: () => ({ url: `/api/v1/.well-known/jwks.json` }),
    }),
    authorize: build.query<AuthorizeApiResponse, AuthorizeApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/authorize`,
        params: {
          client_id: queryArg.clientId,
          redirect_uri: queryArg.redirectUri,
          scope: queryArg.scope,
          response_type: queryArg.responseType,
          state: queryArg.state,
          nonce: queryArg.nonce,
          response_mode: queryArg.responseMode,
          code_challenge: queryArg.codeChallenge,
          code_challenge_method: queryArg.codeChallengeMethod,
          prompt: queryArg.prompt,
        },
      }),
    }),
    token: build.mutation<TokenApiResponse, TokenApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/token`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    me: build.query<MeApiResponse, MeApiArg>({
      query: () => ({ url: `/api/v1/user/me` }),
    }),
    logout: build.query<LogoutApiResponse, LogoutApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/logout`,
        params: {
          id_token_hint: queryArg.idTokenHint,
          client_id: queryArg.clientId,
          post_logout_redirect_uri: queryArg.postLogoutRedirectUri,
          state: queryArg.state,
        },
      }),
    }),
    introspect: build.mutation<IntrospectApiResponse, IntrospectApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/introspect`,
        method: "POST",
        body: queryArg.body,
        headers: {
          Authorization: queryArg.authorization,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as cloudServicesManagerApi };
export type AdministrationSsoGetApiResponse =
  /** status 200 An IActionResult containing a ServiceResponse`1
with the SSO configuration details. */ ServiceResponseOfGetAdministrationSsoResponse;
export type AdministrationSsoGetApiArg = void;
export type AdministrationSsoUpdateApiResponse =
  /** status 200 An IActionResult containing a ServiceResponse`1
with the result of the update operation. */ ServiceResponseOfUpdateAdministrationSsoResponse;
export type AdministrationSsoUpdateApiArg = {
  /** The request containing the updated SSO configuration details. */
  updateAdministrationSsoRequest: UpdateAdministrationSsoRequest;
};
export type AdministrationSsoDeleteApiResponse =
  /** status 200 An IActionResult containing a ServiceResponse`1
with the result of the delete operation. */ ServiceResponseOfDeleteAdministrationSsoResponse;
export type AdministrationSsoDeleteApiArg = {
  deleteAdministrationSsoRequest: DeleteAdministrationSsoRequest;
};
export type AdministrationSsoValidateApiResponse =
  /** status 200 An IActionResult containing a ServiceResponse`1
with the result of the validation operation. */ ServiceResponseOfUpdateAdministrationSsoResponse;
export type AdministrationSsoValidateApiArg = {
  /** The request containing the SSO configuration details to ValidateFlag. */
  updateAdministrationSsoRequest: UpdateAdministrationSsoRequest;
};
export type ApplicationSearchApiResponse =
  /** status 200  */ ServiceResponseOfSearchApplicationResponse;
export type ApplicationSearchApiArg = {
  searchApplicationRequest: SearchApplicationRequest;
};
export type ApplicationUpdateApiResponse =
  /** status 200  */ ServiceResponseOfUpdateApplicationResponse;
export type ApplicationUpdateApiArg = {
  updateApplicationRequest: UpdateApplicationRequest;
};
export type ApplicationDeleteApiResponse =
  /** status 200  */ ServiceResponseOfDeleteApplicationResponse;
export type ApplicationDeleteApiArg = {
  deleteApplicationRequest: DeleteApplicationRequest;
};
export type ClientRegistrationSearchApiResponse =
  /** status 200  */ ServiceResponseOfSearchClientRegistrationResponse;
export type ClientRegistrationSearchApiArg = {
  searchClientRegistrationRequest: SearchClientRegistrationRequest;
};
export type ClientRegistrationUpdateApiResponse =
  /** status 200  */ ServiceResponseOfUpdateClientRegistrationResponse;
export type ClientRegistrationUpdateApiArg = {
  updateClientRegistrationRequest: UpdateClientRegistrationRequest;
};
export type ClientRegistrationDeleteApiResponse =
  /** status 200  */ ServiceResponseOfDeleteClientRegistrationResponse;
export type ClientRegistrationDeleteApiArg = {
  deleteClientRegistrationRequest: DeleteClientRegistrationRequest;
};
export type ClientRegistrationGetApiResponse =
  /** status 200  */ ServiceResponseOfGetClientRegistrationResponse;
export type ClientRegistrationGetApiArg = {
  /** ClientRegistration ID */
  id: string;
};
export type ConsumptionPageUsersApiResponse =
  /** status 200 An IActionResult containing a ServiceResponse with the search results for users with active subscriptions. */ ServiceResponseOfSearchUsersWithActiveSubscriptionResponse;
export type ConsumptionPageUsersApiArg = {
  /** The search criteria used to filter users with active subscriptions. This parameter must not be null. */
  searchUsersWithActiveSubscriptionRequest: SearchUsersWithActiveSubscriptionRequest;
};
export type ConsumptionPagePeriodsApiResponse =
  /** status 200 A task that represents the asynchronous operation. The task result contains an IActionResult with a
            ServiceResponse holding the search results for periods of active subscriptions. */ ServiceResponseOfSearchPeriodsOfActiveSubscriptionsResponse;
export type ConsumptionPagePeriodsApiArg = {
  /** The search criteria for filtering periods of active subscriptions. Must include any required parameters for the
                search operation. */
  searchPeriodsOfActiveSubscriptionsRequest: SearchPeriodsOfActiveSubscriptionsRequest;
};
export type ConsumptionPageQuotasApiResponse =
  /** status 200 An IActionResult containing a ServiceResponse with the results of the user consumption quota search operation. */ ServiceResponseOfSearchUserConsumptionsSerialResponse;
export type ConsumptionPageQuotasApiArg = {
  /** The search criteria and parameters for retrieving user consumption quotas. Must include valid user
                identification and any relevant filters. */
  searchUserConsumptionsSerialRequest: SearchUserConsumptionsSerialRequest;
};
export type CsmConfigurationGetCsmConfigurationApiResponse =
  /** status 200 The CSM configuration wrapped in a service response. */ CsmConfigurationResponse;
export type CsmConfigurationGetCsmConfigurationApiArg = void;
export type DocumentsDownloadApiResponse = unknown;
export type DocumentsDownloadApiArg = {
  /** The product identifier used to locate documents in storage. */
  product: string;
  /** The document type used to locate documents in storage. */
  documentType: string;
};
export type HealthCheckHealthCheckApiResponse = unknown;
export type HealthCheckHealthCheckApiArg = void;
export type HealthCheckHealthCheckBackEndApiResponse =
  /** status 200 An IActionResult containing a ServiceResponse`1 with the health
            check result. */ ServiceResponseOfHealthCheckResponse;
export type HealthCheckHealthCheckBackEndApiArg = void;
export type OrderSearchApiResponse =
  /** status 200 An IActionResult containing a ServiceResponse`1 object with the search results. The
            response includes the search results or an error message if the operation fails. */ ServiceResponseOfSearchOrderResponse;
export type OrderSearchApiArg = {
  /** The search request containing the criteria for filtering orders. This parameter must not be null. */
  searchOrderRequest: SearchOrderRequest;
};
export type OrderGetApiResponse =
  /** status 200 An IActionResult containing a ServiceResponse`1 with the order details in a GetOrderResponse object. If the order is not found, the response will indicate an error. */ ServiceResponseOfGetOrderResponse;
export type OrderGetApiArg = {
  /** The unique identifier of the order to retrieve. Cannot be null or empty. */
  id: string;
};
export type ProductSearchOwnApiResponse =
  /** status 200 An IActionResult containing a ServiceResponse with the search results for the user's own products. */ ServiceResponseOfSearchOwnProductFamilyResponse;
export type ProductSearchOwnApiArg = {
  /** The search criteria for filtering the user's own products. Must include valid parameters for the search
                operation. */
  searchOwnProductFamilyRequest: SearchOwnProductFamilyRequest;
};
export type ProductGetOwnApiResponse =
  /** status 200 An IActionResult containing a ServiceResponse with the user's own products. */ ServiceResponseOfGetOwnProductResponse;
export type ProductGetOwnApiArg = {
  /** The request containing the parameters for retrieving the user's own products. */
  getOwnProductRequest: GetOwnProductRequest;
};
export type ProductSearchApiResponse =
  /** status 200 An IActionResult containing a ServiceResponse with the search results for products. */ ServiceResponseOfSearchProductResponse;
export type ProductSearchApiArg = {
  /** The search criteria and parameters used to filter and retrieve products. */
  searchProductRequest: SearchProductRequest;
};
export type RegistrationPageCompanyApiResponse =
  /** status 200  */ ServiceResponseOfRegisterCompanyResponse;
export type RegistrationPageCompanyApiArg = {
  /** The registration request containing company, serial number and user information. */
  registerCompanyRequest: RegisterCompanyRequest;
};
export type SerialNumberSearchApiResponse =
  /** status 200  */ ServiceResponseOfSearchSerialNumberResponse;
export type SerialNumberSearchApiArg = {
  searchSerialNumberRequest: SearchSerialNumberRequest;
};
export type SerialNumberCreateApiResponse =
  /** status 200 An IActionResult containing a ServiceResponse`1 with the outcome of the create serial number operation. */ ServiceResponseOfCreateSerialNumberResponse;
export type SerialNumberCreateApiArg = {
  /** An object containing the details of the serial number to be created, including the authenticated user information and the product ID. */
  createSerialNumberRequest: CreateSerialNumberRequest;
};
export type SerialNumberActivationRenewalSerialNumberApiResponse =
  /** status 200 An IActionResult containing a ServiceResponse`1 with the
            outcome of the activation renewal operation. */ ServiceResponseOfActivationRenewalResponse;
export type SerialNumberActivationRenewalSerialNumberApiArg = {
  /** An object containing the activation renewal details, including the serial number and user authentication
                information. Cannot be null. */
  activationRenewalRequest: ActivationRenewalRequest;
};
export type SubscriptionSearchUserApiResponse =
  /** status 200  */ ServiceResponseOfSearchSubscriptionUserResponse;
export type SubscriptionSearchUserApiArg = {
  searchSubscriptionUserRequest: SearchSubscriptionUserRequest;
};
export type SubscriptionSearchApiResponse =
  /** status 200  */ ServiceResponseOfSearchActiveSubscriptionResponse;
export type SubscriptionSearchApiArg = {
  searchActiveSubscriptionRequest: SearchActiveSubscriptionRequest;
};
export type SubscriptionUpdateApiResponse =
  /** status 200  */ ServiceResponseOfUpdateUserSubscriptionResponse;
export type SubscriptionUpdateApiArg = {
  updateUserSubscriptionRequest: UpdateUserSubscriptionRequest;
};
export type SubscriptionDeleteApiResponse =
  /** status 200  */ ServiceResponseOfUpdateUserSubscriptionResponse;
export type SubscriptionDeleteApiArg = {
  updateUserSubscriptionRequest: UpdateUserSubscriptionRequest;
};
export type TenantSearchApiResponse =
  /** status 200 An IActionResult containing a ServiceResponse`1 with the search results
            encapsulated in a SearchTenantResponse object. */ ServiceResponseOfSearchTenantResponse;
export type TenantSearchApiArg = {
  /** The request containing the search criteria and user authentication data. */
  searchTenantRequest: SearchTenantRequest;
};
export type TermsAndConditionsSearchAuthenticatedApiResponse =
  /** status 200  */ ServiceResponseOfSearchTermsAndConditionsBySerialNumberResponse;
export type TermsAndConditionsSearchAuthenticatedApiArg = {
  searchTermsAndConditionsBySerialNumberRequest: SearchTermsAndConditionsBySerialNumberRequest;
};
export type TermsAndConditionsSearchPublicApiResponse =
  /** status 200  */ ServiceResponseOfSearchTermsAndConditionsBySerialNumberResponse;
export type TermsAndConditionsSearchPublicApiArg = {
  searchTermsAndConditionsBySerialNumberRequest: SearchTermsAndConditionsBySerialNumberRequest;
};
export type UserActivityLogSearchApiResponse =
  /** status 200  */ ServiceResponseOfSearchUserActivityLogResponse;
export type UserActivityLogSearchApiArg = {
  searchUserActivityLogRequest: SearchUserActivityLogRequest;
};
export type UserSearchApiResponse =
  /** status 200 An IActionResult containing a ServiceResponse`1 with the search results. The
            response includes a SearchUserResponse object with the matching user data or an error message if
            the search fails. */ ServiceResponseOfSearchUserResponse;
export type UserSearchApiArg = {
  /** The search criteria and associated data for the operation. Must not be null. */
  searchUserRequest: SearchUserRequest;
};
export type UserUpdateApiResponse =
  /** status 200 An IActionResult containing a ServiceResponse`1 of type UpdateUserResponse. The response indicates the success or failure of the update operation. */ ServiceResponseOfUpdateUserResponse;
export type UserUpdateApiArg = {
  /** The request containing the user data to update. Must include valid user information. */
  updateUserRequest: UpdateUserRequest;
};
export type UserDeleteApiResponse =
  /** status 200 An IActionResult containing a ServiceResponse`1 with the result of the delete
            operation. The response includes details about the success or failure of the operation. */ ServiceResponseOfNothing;
export type UserDeleteApiArg = {
  /** The request containing the details of the user to delete. Must include valid user identification information. */
  deleteUserRequest: DeleteUserRequest;
};
export type UserQuotaGetApiResponse =
  /** status 200  */ ServiceResponseOfGetUserQuotaResponse;
export type UserQuotaGetApiArg = {
  serviceSlug: string;
  userId: string;
};
export type UserQuotaPostApiResponse =
  /** status 200  */ ServiceResponseOfUpdateUserQuotaResponse;
export type UserQuotaPostApiArg = {
  serviceSlug: string;
  userId: string;
  /** A JSON data like:{
      "consumption": 100
    } */
  updateUserQuotaRequest: UpdateUserQuotaRequest;
};
export type VersionVersionApiResponse =
  /** status 200 The version information wrapped in a service response. */ string;
export type VersionVersionApiArg = void;
export type GetApiV1WellKnownOpenidConfigurationApiResponse =
  /** status 200 Discovery metadata (JSON) */ {
    issuer: string;
    authorization_endpoint: string;
    token_endpoint: string;
    end_session_endpoint?: string;
    userinfo_endpoint?: string;
    jwks_uri: string;
    grant_types_supported?: string[];
    response_types_supported?: string[];
    response_modes_supported?: string[];
    scopes_supported?: string[];
    claims_supported?: string[];
    id_token_signing_alg_values_supported?: string[];
    code_challenge_methods_supported?: string[];
    subject_types_supported?: string[];
    prompt_values_supported?: string[];
    token_endpoint_auth_methods_supported?: string[];
    claims_parameter_supported?: boolean;
    request_parameter_supported?: boolean;
    request_uri_parameter_supported?: boolean;
    tls_client_certificate_bound_access_tokens?: boolean;
    authorization_response_iss_parameter_supported?: boolean;
  };
export type GetApiV1WellKnownOpenidConfigurationApiArg = void;
export type GetApiV1WellKnownJwksJsonApiResponse = /** status 200 JWKS JSON */ {
  keys: {
    kty?: string | null;
    use?: string | null;
    kid?: string | null;
    alg?: string | null;
    crv?: string | null;
    d?: string | null;
    dp?: string | null;
    dq?: string | null;
    e?: string | null;
    k?: string | null;
    n?: string | null;
    p?: string | null;
    q?: string | null;
    qi?: string | null;
    x?: string | null;
    x5t?: string | null;
    "x5t#S256"?: string | null;
    x5u?: string | null;
    y?: string | null;
    key_ops?: string[] | null;
    oth?: string[] | null;
    x5c?: string[] | null;
  }[];
};
export type GetApiV1WellKnownJwksJsonApiArg = void;
export type AuthorizeApiResponse = unknown;
export type AuthorizeApiArg = {
  /** The unique identifier of the application requesting authorization. */
  clientId: string;
  /** The URL to which the user will be redirected after successful authorization. */
  redirectUri: string;
  /** A space-separated list of permissions the application requests (e.g., "openid", "profile", "email"). Must include "openid". */
  scope: string;
  /** Specifies the type of response the client expects (e.g., "code", "id_token", "code id_token"). */
  responseType: string;
  /** An opaque value used to maintain state between the request and callback to prevent CSRF attacks. */
  state: string;
  /** An opaque value used to associate a client session with an ID Token and mitigate replay attacks. */
  nonce: string;
  /** Indicates how the response parameters are returned (e.g., "fragment", "form_post"). */
  responseMode: string;
  /** The code challenge value, typically a Base64-URL-encoded SHA256 hash of the code verifier. */
  codeChallenge: string;
  /** Specifies the code challenge method: either plain or S256. */
  codeChallengeMethod: string;
  /** Specifies whether the server should prompt the user for re-authentication or consent (e.g., "login", "consent"). */
  prompt?: string;
};
export type TokenApiResponse = /** status 200 Successful token response */ {
  /** An opaque string that the client uses to access protected resources. */
  access_token?: string;
  /** Usually "Bearer", indicating how the access token should be used. */
  token_type?: string;
  /** The duration in seconds until the access token expires. */
  expires_in?: number;
  /** A token that can be used to obtain a new access token without re-prompting the user. */
  refresh_token?: string;
  /** An optional token containing information about the authenticated user. */
  id_token?: string;
  /** The permissions granted to the access token. */
  scope?: string;
};
export type TokenApiArg = {
  body: {
    /** Specifies the type of authorization grant being used. Common values: authorization_code, refresh_token, client_credentials. */
    grant_type: string;
    /** The authorization code received after successful authorization. */
    code?: string;
    /** The URL to which the user was initially redirected during the authorization flow. */
    redirect_uri?: string;
    /** Client identifier used for authentication. */
    client_id?: string;
    /** Client secret used for authentication. */
    client_secret?: string;
    /** Used in the refresh_token grant type to obtain a new access token. */
    refresh_token?: string;
    /** Specifies the permissions requested by the client application. */
    scope?: string;
  };
};
export type MeApiResponse = /** status 200 UserInfo response */ {
  /** Subject identifier for the end-user */
  sub: string;
  /** End-user's email address */
  email: string;
  /** Issuer Identifier */
  iss: string;
  /** Audience that this ID Token is intended for */
  aud: string;
  /** Role of the end-user */
  role: string;
};
export type MeApiArg = void;
export type LogoutApiResponse = unknown;
export type LogoutApiArg = {
  /** ID Token previously issued to the user, to indicate which session to logout. */
  idTokenHint?: string;
  /** Client identifier of the relying party requesting logout. */
  clientId?: string;
  /** URL to which the user agent is redirected after logout. */
  postLogoutRedirectUri?: string;
  /** Opaque value used to maintain state between the logout request and callback, useful for CSRF protection. */
  state?: string;
};
export type IntrospectApiResponse =
  /** status 200 Successful introspection response */ {
    /** Indicates whether the access token is active. */
    active?: boolean;
    /** The issuer identifier of the access token. */
    iss?: string;
    /** The username of the authenticated user. */
    username?: string;
    /** The subject identifier of the authenticated user. */
    sub?: string;
    /** The permissions granted to the access token. */
    scope?: string;
    /** The unique identifier for the token. */
    jti?: string;
    /** The type of the token. */
    token_type?: string;
    /** The usage of the token. */
    token_usage?: string;
    /** The client identifier of the application. */
    client_id?: string;
    /** The issued at time of the access token. */
    iat?: number;
    /** The not before time of the access token. */
    nbf?: number;
    /** The expiration time of the access token. */
    exp?: number;
    /** The audience for the access token. */
    aud?: string;
    /** The email address of the authenticated user. */
    email?: string;
    /** The name of the authenticated user. */
    name?: string;
    /** The role of the authenticated user. */
    role?: string;
  };
export type IntrospectApiArg = {
  /** HTTP Basic authentication header using client_id as username and client_secret as password. Example: 'Authorization: Basic base64(client_id:client_secret)'. */
  authorization: string;
  body: {
    /** The access token to introspect. */
    token: string;
    /** The type of the token to introspect. */
    token_type_hint?: string;
  };
};
export type ClientRegistration = {
  id?: string | null;
  tenantId?: string | null;
  issuer?: string | null;
  providerName?: string | null;
  configurationEndpoint?: string | null;
  clientId?: string | null;
  clientSecret?: string | null;
  redirectUri?: string | null;
  postLogoutRedirectUri?: string | null;
  scopes?: string[] | null;
  enabled?: boolean | null;
  inserted?: string | null;
  updated?: string | null;
};
export type GetAdministrationSsoResponse = {
  administrationSso?: ClientRegistration | null;
};
export type ServiceResponseOfGetAdministrationSsoResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: GetAdministrationSsoResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type UpdateAdministrationSsoResponse = object;
export type ServiceResponseOfUpdateAdministrationSsoResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: UpdateAdministrationSsoResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type UpdateAdministrationSsoRequest = {
  configurationEndpoint?: string;
  clientId?: string;
  clientSecret?: string;
};
export type DeleteAdministrationSsoResponse = object;
export type ServiceResponseOfDeleteAdministrationSsoResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: DeleteAdministrationSsoResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type DeleteAdministrationSsoRequest = {
  tenantId?: string | null;
};
export type Application = {
  id?: string | null;
  slug?: string;
  name?: string;
  description?: string | null;
  publisher?: string | null;
  secret?: string | null;
  permissions?: string[] | null;
  clientType?: string | null;
  consentType?: string | null;
  redirectUris?: string[] | null;
  postLogoutRedirectUris?: string[] | null;
  scopes?: string[] | null;
  resourceScopes?: string[] | null;
};
export type SearchApplicationResponse = {
  applications?: Application[] | null;
  count?: number;
};
export type ServiceResponseOfSearchApplicationResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: SearchApplicationResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type PagedRequest = {
  page?: number | null;
  pageSize?: number | null;
};
export type SearchApplicationBaseRequest = PagedRequest & {
  postLogoutRedirectUri?: string | null;
  redirectUri?: string | null;
};
export type SearchApplicationRequest = SearchApplicationBaseRequest & object;
export type UpdateApplicationResponse = {
  application?: Application | null;
};
export type ServiceResponseOfUpdateApplicationResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: UpdateApplicationResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type UpdateApplicationBaseRequest = {
  application?: Application | null;
  emptyResponse?: boolean | null;
};
export type UpdateApplicationRequest = UpdateApplicationBaseRequest & object;
export type DeleteApplicationResponse = object;
export type ServiceResponseOfDeleteApplicationResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: DeleteApplicationResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type DeleteApplicationBaseRequest = {
  applicationId?: string;
};
export type DeleteApplicationRequest = DeleteApplicationBaseRequest & object;
export type ClientRegistrationWithDomains = ClientRegistration & {
  domains?: string[] | null;
};
export type SearchClientRegistrationResponse = {
  clientRegistrations?: ClientRegistrationWithDomains[] | null;
};
export type ServiceResponseOfSearchClientRegistrationResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: SearchClientRegistrationResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type SearchClientRegistrationBaseRequest = PagedRequest & {
  tenantId?: string | null;
  providerName?: string | null;
  issuer?: string | null;
  domain?: string | null;
  postLogoutRedirectUri?: string | null;
  redirectUri?: string | null;
};
export type SearchClientRegistrationRequest =
  SearchClientRegistrationBaseRequest & object;
export type UpdateClientRegistrationResponse = object;
export type ServiceResponseOfUpdateClientRegistrationResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: UpdateClientRegistrationResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type UpdateClientRegistrationBaseRequest = {
  clientRegistration?: ClientRegistrationWithDomains | null;
  updater?: string | null;
};
export type User = {
  id?: string | null;
  email?: string | null;
  name?: string | null;
  userRole?: UserRole;
  tenantId?: string | null;
  enableSso?: boolean | null;
  enableSignIn?: boolean | null;
};
export type UpdateClientRegistrationRequest =
  UpdateClientRegistrationBaseRequest & {
    authenticatedUser?: User | null;
  };
export type DeleteClientRegistrationResponse = object;
export type ServiceResponseOfDeleteClientRegistrationResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: DeleteClientRegistrationResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type DeleteClientRegistrationBaseRequest = {
  clientRegistrationId?: string;
};
export type DeleteClientRegistrationRequest =
  DeleteClientRegistrationBaseRequest & {
    authenticatedUser?: User | null;
  };
export type GetClientRegistrationResponse = {
  clientRegistration?: ClientRegistrationWithDomains | null;
};
export type ServiceResponseOfGetClientRegistrationResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: GetClientRegistrationResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type UserItem = {
  id?: string;
  email?: string;
  name?: string | null;
  userRole?: UserRole | null;
  tenantId?: string | null;
  enableSso?: boolean | null;
  enableSignIn?: boolean | null;
  magicToken?: string | null;
  magicTokenCreated?: string | null;
  magicTokenCreater?: string | null;
  inserted?: string | null;
  updated?: string | null;
  updater?: string | null;
};
export type SearchUsersWithActiveSubscriptionResponse = {
  users?: UserItem[];
  count?: number;
};
export type ServiceResponseOfSearchUsersWithActiveSubscriptionResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: SearchUsersWithActiveSubscriptionResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type SearchUsersWithActiveSubscriptionRequest = PagedRequest & {
  productId?: string | null;
  productReference?: string | null;
  tenantId?: string | null;
  search?: string | null;
};
export type PeriodRangeItem = {
  startPeriod?: string;
  endPeriod?: string;
};
export type SearchPeriodsOfActiveSubscriptionsResponse = {
  periods?: PeriodRangeItem[];
};
export type ServiceResponseOfSearchPeriodsOfActiveSubscriptionsResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: SearchPeriodsOfActiveSubscriptionsResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type SearchPeriodsOfActiveSubscriptionsRequest = {
  productId?: string | null;
  productReference?: string | null;
  tenantId?: string | null;
  userId?: string | null;
};
export type UserConsumptionItem = {
  userId?: string;
  serviceName?: string;
  startPeriod?: string;
  endPeriod?: string;
  percentage?: number;
};
export type SearchUserConsumptionsSerialResponse = {
  consumptions?: UserConsumptionItem[];
};
export type ServiceResponseOfSearchUserConsumptionsSerialResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: SearchUserConsumptionsSerialResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type SearchUserConsumptionsSerialRequest = {
  productId?: string | null;
  productReference?: string | null;
  userId?: string;
  startPeriod?: string;
  endPeriod?: string;
};
export type StoneCopilotUris = {
  frequentlyAskedQuestions?: string;
  specificTermsAndConditions?: string;
  shield?: string;
};
export type CsmConfigurationResponse = {
  stoneCopilot?: StoneCopilotUris;
};
export type EnabledLogLevel = {
  error?: boolean;
  warning?: boolean;
  debug?: boolean;
  information?: boolean;
};
export type HealthCheckResponse = {
  tokenContainerConnection?: HealthCheckStatus;
  userActivityLogContainerConnection?: HealthCheckStatus;
  authorizationContainerConnection?: HealthCheckStatus;
  dbConnection?: HealthCheckStatus;
  azureQueueConnection?: HealthCheckStatus;
  existMigrations?: HealthCheckStatus;
  keyVaultConnection?: HealthCheckStatus;
  appConfigurationConnection?: HealthCheckStatus;
  enabledLogLevel?: EnabledLogLevel | null;
};
export type ServiceResponseOfHealthCheckResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: HealthCheckResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type Order = {
  id?: string;
  customerId?: string;
  customerCode?: string;
  referenceDate?: string;
  referenceEmail?: string;
  branchCode?: string;
  orderNumber?: string;
  productTypeName?: string;
  tenantId?: string | null;
};
export type SearchOrderResponse = {
  orders?: Order[];
  count?: number;
};
export type ServiceResponseOfSearchOrderResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: SearchOrderResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type SearchOrderRequest = PagedRequest & {
  orderIds?: string[] | null;
  orderNumber?: string | null;
  tenantId?: string | null;
  search?: string | null;
};
export type GetOrderResponse = {
  order?: Order | null;
};
export type ServiceResponseOfGetOrderResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: GetOrderResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type SearchOwnProductFamilyResponse = {
  productFamilies?: string[];
  count?: number;
};
export type ServiceResponseOfSearchOwnProductFamilyResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: SearchOwnProductFamilyResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type SearchOwnProductFamilyRequest = {
  tenantId?: string | null;
  productTypeName?: string | null;
  productTypeNames?: string[] | null;
  productReference?: string | null;
};
export type OwnServiceItem = {
  id?: string;
  name?: string;
};
export type OwnProductItem = {
  id?: string;
  name?: string;
  scope?: string;
  expiryDate?: string;
  services?: OwnServiceItem[] | null;
};
export type GetOwnProductResponse = {
  products?: OwnProductItem[];
};
export type ServiceResponseOfGetOwnProductResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: GetOwnProductResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type GetOwnProductRequest = object;
export type Product = {
  id?: string;
  name?: string;
  /** Product's code of CAREL portal */
  productTypeName?: string;
  description?: string | null;
  /** Logical group family for a product */
  productReference?: string;
  /** Time a subscription last */
  productInterval?: TimeInterval;
  /** Time (in seconds) a user have to activate a serial number */
  serialNumberLife?: number | null;
};
export type ProductData = Product & {
  inserted?: string;
  updated?: string;
  updater?: string;
  enabled?: boolean;
};
export type Service = {
  id?: string;
  name?: string;
  description?: string | null;
  quota?: number;
  quotaUoM?: string | null;
  quotaVisible?: boolean;
  quotaInterval?: TimeInterval;
  slug?: string;
};
export type ServiceData = Service & {
  inserted?: string;
  updated?: string;
  enabled?: boolean;
};
export type ProductItem = ProductData & {
  services?: ServiceData[] | null;
};
export type SearchProductResponse = {
  products?: ProductItem[] | null;
  count?: number | null;
};
export type ServiceResponseOfSearchProductResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: SearchProductResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type SearchProductRequest = {
  tenantId?: string | null;
  productTypeName?: string | null;
  productTypeNames?: string[] | null;
  productReference?: string | null;
};
export type RegisterCompanyResponse = object;
export type ServiceResponseOfRegisterCompanyResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: RegisterCompanyResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type RegisterCompanyRequest = {
  email?: string;
  company?: string;
  serialNumber?: string;
  productId?: string;
};
export type ProductSerialNumber = {
  id?: string;
  serialNumber?: string;
  orderId?: string;
  inserted?: string;
  updated?: string;
  updater?: string;
  expired?: string | null;
  subscriptionExpirationDate?: string | null;
  notes?: string | null;
};
export type SerialNumberData = ProductSerialNumber & {
  productId?: string;
  enabled?: boolean;
};
export type SearchSerialNumberResponse = {
  serialNumbers?: SerialNumberData[];
  count?: number;
};
export type ServiceResponseOfSearchSerialNumberResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: SearchSerialNumberResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type SearchSerialNumberRequest = PagedRequest & {
  productId?: string | null;
  productReference?: string | null;
  productIds?: string[] | null;
  tenantId?: string | null;
  isAssigned?: boolean | null;
  orderIds?: string[] | null;
};
export type CreateSerialNumberResponse = {
  serialNumber?: string;
};
export type ServiceResponseOfCreateSerialNumberResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: CreateSerialNumberResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type CreateSerialNumberRequest = {
  productId?: string;
  notes?: string;
};
export type ActivationRenewalResponse = {
  activatedOrders?: string[];
  renewedUsers?: string[];
};
export type ServiceResponseOfActivationRenewalResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: ActivationRenewalResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type ActivationRenewalRequest = {
  tenantId?: string | null;
  serialNumbers?: string[];
  productIds?: string[];
  autoRenew?: boolean;
};
export type SearchSubscriptionUserResponse = {
  users?: UserItem[];
  count?: number;
};
export type ServiceResponseOfSearchSubscriptionUserResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: SearchSubscriptionUserResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type SearchSubscriptionUserRequest = PagedRequest & {
  hasActiveSubscription?: boolean;
  productId?: string | null;
  productReference?: string | null;
  tenantId?: string | null;
};
export type SubscriptionData = {
  serialNumberId?: string;
  userId?: string;
  inserted?: string | null;
  updated?: string | null;
  updater?: string | null;
  enabled?: boolean;
};
export type SearchActiveSubscriptionResponse = {
  subscriptions?: SubscriptionData[];
  users?: User[] | null;
  serialNumbers?: SerialNumberData[] | null;
  count?: number;
};
export type ServiceResponseOfSearchActiveSubscriptionResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: SearchActiveSubscriptionResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type SearchActiveSubscriptionRequest = PagedRequest & {
  productId?: string | null;
  productReference?: string | null;
  tenantId?: string | null;
  search?: string | null;
  includeUserDetails?: boolean;
  includeSerialNumberDetails?: boolean;
};
export type UpdateUserSubscriptionResponse = object;
export type ServiceResponseOfUpdateUserSubscriptionResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: UpdateUserSubscriptionResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type UpdateUserSubscriptionRequest = {
  userId?: string;
  serialNumberId?: string;
};
export type Tenant = {
  id?: string;
  customerCode?: string | null;
  name?: string;
};
export type TenantSso = {
  tenant?: Tenant;
  hasClientRegistration?: boolean;
};
export type SearchTenantResponse = {
  tenantsSso?: TenantSso[];
  count?: number;
};
export type ServiceResponseOfSearchTenantResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: SearchTenantResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type SearchTenantRequest = PagedRequest & {
  tenantIds?: string[] | null;
  name?: string | null;
  search?: string | null;
  customerCode?: string | null;
};
export type TermsAndConditionsInfos = {
  productId?: string;
  productName?: string;
  productTermsAndConditionsUrl?: string;
};
export type SearchTermsAndConditionsBySerialNumberResponse = {
  termsAndConditions?: TermsAndConditionsInfos[];
};
export type ServiceResponseOfSearchTermsAndConditionsBySerialNumberResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: SearchTermsAndConditionsBySerialNumberResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type SearchTermsAndConditionsBySerialNumberRequest = {
  serialNumbers?: string[];
};
export type UserActivityLogData = {
  id?: string | null;
  userId?: string;
  operation?: UserActivityLogOperation;
  data?: string | null;
  inserted?: string | null;
  error?: number | null;
};
export type UserData = User & {
  magicToken?: string | null;
  magicTokenCreated?: string | null;
  magicTokenCreater?: string | null;
  inserted?: string | null;
  updated?: string | null;
  updater?: string | null;
};
export type SearchUserActivityLogResponse = {
  logs?: UserActivityLogData[];
  users?: UserData[];
  count?: number;
};
export type ServiceResponseOfSearchUserActivityLogResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: SearchUserActivityLogResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type SearchUserActivityLogRequest = PagedRequest & {
  operation?: UserActivityLogOperation | null;
  userId?: string | null;
};
export type SearchUserResponse = {
  users?: User[] | null;
  userIds?: string[] | null;
  count?: number;
};
export type ServiceResponseOfSearchUserResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: SearchUserResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type SearchUserBaseRequest = PagedRequest & {
  tenantId?: string | null;
  search?: string | null;
  email?: string | null;
  name?: string | null;
  userIds?: string[] | null;
  returnOnlyId?: boolean | null;
};
export type SearchUserRequest = SearchUserBaseRequest & object;
export type UpdateUserResponse = {
  user?: User;
};
export type ServiceResponseOfUpdateUserResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: UpdateUserResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type UpdateUserRequest = {
  user?: User;
  emptyResponse?: boolean | null;
};
export type Nothing = object;
export type ServiceResponseOfNothing = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: Nothing | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type DeleteUserRequest = {
  userId?: string;
};
export type GetUserQuotaResponse = {
  service?: string;
  remainingQuota?: number;
};
export type ServiceResponseOfGetUserQuotaResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: GetUserQuotaResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type UpdateUserQuotaResponse = object;
export type ServiceResponseOfUpdateUserQuotaResponse = {
  /** The result of the operation performed by the function. Populated only if the operation succeeded; null in case of an error. */
  payload?: UpdateUserQuotaResponse | null;
  /** The error code generated by the function. Populated only in case of failure; null if the operation succeeded. */
  error?: number | null;
};
export type UpdateUserQuotaRequest = {
  consumption?: number;
};
export enum UserRole {
  TenantUser = 0,
  TenantAdmin = 1,
  SystemContributor = 2,
  SystemAdmin = 3,
  SystemReader = 4,
}
export enum HealthCheckStatus {
  Bad = 10,
  SomeIssue = 50,
  Good = 90,
}
export enum TimeInterval {
  Daily = 0,
  Weekly = 1,
  Monthly = 2,
  Bimestral = 3,
  Quarterly = 4,
  Semestral = 5,
  Annual = 6,
  Biennial = 7,
  Triennial = 8,
  Quadrennial = 9,
  Quinquennial = 10,
  Decennial = 11,
}
export enum UserActivityLogOperation {
  UpdateAdministrationSso = 0,
  DeleteAdministrationSso = 1,
  UpdateApplication = 2,
  DeleteApplication = 3,
  UpdateClientRegistration = 4,
  DeleteClientRegistration = 5,
  UpdateUser = 6,
  DeleteUser = 7,
  EnqueueConsumption = 8,
  RegisterCompany = 9,
  UpdateUserSubscription = 10,
  ActivationRenewalSerialNumber = 11,
  CreateSerialNumber = 12,
}
export const {
  useAdministrationSsoGetQuery,
  useAdministrationSsoUpdateMutation,
  useAdministrationSsoDeleteMutation,
  useAdministrationSsoValidateMutation,
  useApplicationSearchMutation,
  useApplicationUpdateMutation,
  useApplicationDeleteMutation,
  useClientRegistrationSearchMutation,
  useClientRegistrationUpdateMutation,
  useClientRegistrationDeleteMutation,
  useClientRegistrationGetQuery,
  useConsumptionPageUsersMutation,
  useConsumptionPagePeriodsMutation,
  useConsumptionPageQuotasMutation,
  useCsmConfigurationGetCsmConfigurationQuery,
  useDocumentsDownloadQuery,
  useHealthCheckHealthCheckQuery,
  useHealthCheckHealthCheckBackEndQuery,
  useOrderSearchMutation,
  useOrderGetQuery,
  useProductSearchOwnMutation,
  useProductGetOwnQuery,
  useProductSearchMutation,
  useRegistrationPageCompanyMutation,
  useSerialNumberSearchMutation,
  useSerialNumberCreateMutation,
  useSerialNumberActivationRenewalSerialNumberMutation,
  useSubscriptionSearchUserMutation,
  useSubscriptionSearchMutation,
  useSubscriptionUpdateMutation,
  useSubscriptionDeleteMutation,
  useTenantSearchMutation,
  useTermsAndConditionsSearchAuthenticatedMutation,
  useTermsAndConditionsSearchPublicMutation,
  useUserActivityLogSearchMutation,
  useUserSearchMutation,
  useUserUpdateMutation,
  useUserDeleteMutation,
  useUserQuotaGetQuery,
  useUserQuotaPostMutation,
  useVersionVersionQuery,
  useGetApiV1WellKnownOpenidConfigurationQuery,
  useGetApiV1WellKnownJwksJsonQuery,
  useAuthorizeQuery,
  useTokenMutation,
  useMeQuery,
  useLogoutQuery,
  useIntrospectMutation,
} = injectedRtkApi;
